import { StudioFilter } from './StudioFilter'

export default StudioFilter
